import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { UnifiedLoginGuard } from '@monorepo/services';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./app-shell/app-shell.module').then((m) => m.AppShellModule),
    canActivate: [UnifiedLoginGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
